var max_retries = 5;

async function mgPostData(args, endpoint) {
  try {
    const body = JSON.stringify(args);

    const response = await fetch(`/apps/amv_tax_app_prod/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: body
    });

    return await response.json();
  }
  catch (error) {
    // return {error: `${error.name}: ${error.message}`};
    console.error(error);
    return {error: "Something went wrong"};
  }
}

async function mgRedirectToInvoiceURL(invoice_url) {
  try {
    const response = await fetch(invoice_url);

    if (response.ok){
      window.location.href = invoice_url;
    } else {
      throw "Unable to load invoice URL";
    }
  } catch(error) {
    if ( max_retries > 1 ) {
      max_retries--;
      setTimeout(function() { mgRedirectToInvoiceURL(invoice_url) }, 500);
    } else {
      max_retries = 5;
      mgHandleError(error.message);
    }
  }
}

function mgDisableButtons(disable) {
  const proceed_btn = document.getElementById("address-submit");
  const cancel_btn = document.querySelector(".cancel-btn");

  if (proceed_btn && cancel_btn) {
    proceed_btn.disabled = disable;
    proceed_btn.classList.toggle("disable-btn");

    cancel_btn.disabled = disable;
    cancel_btn.classList.toggle("disable-btn");
  }
}

function mgHandleError(error) {
  let error_msg_holder = document.getElementById("error-message");
  if (error_msg_holder) {
    error_msg_holder.innerText = error + '. Please reload the page and try again.';
    error_msg_holder.style.display = 'block';
  }

  mgDisableButtons(false);
}

async function mgUpdateLineItems(line_items) {
  try {
    // AJAX Cart API
    const response = await fetch('/cart.js');
    const cart_data = await response.json();

    cart_data.items.forEach(item => {
      let found = false;
      line_items.forEach(li => {
        if (li.variant_id == item.variant_id) {
          found = true;
          li.quantity = item.quantity;
        }
      });
      // if (!found) {
      //   add to line_items if needed
      // }
      // remove items that are no longer present (if needed)
    });

    return true;
  }
  catch (error) {
    console.error(error.message);
    return false;
  }
}

function mgAddDiscounts(line_items) {
  const line_item_rows = document.querySelectorAll(".tt-shopcart-table tr");

  for (let i = 0; i < line_item_rows.length; i++) {
    let variant_url = line_item_rows[i].querySelector("td > h2.tt-title > a")?.href;
    if (variant_url) {
      let variant_id = variant_url.match(/variant=(\d+)/);
      if (variant_id) {
        variant_id = variant_id[1];

        for (let li of line_items) {
          if (li.variant_id == variant_id) {
            let discounted_price = line_item_rows[i].querySelector("td > div.tt-price > span[bss-b2b-item-final-price]");
            if (discounted_price) {
              discounted_price = Number(discounted_price.innerText.match(/[\d+.\d+|\d+]+/)[0]);
              let price = Number(li.priceEach);

              if (discounted_price < price) {
                li.discount_value = (price - discounted_price).toFixed(2);
              }
            }
            break;
          }
        }
      }
    }
  }
}

async function mgCustomCheckout(address=null, tax_exempt=false) {
  const shopify_domain = document.getElementById('mg-info').dataset.domain;
  const cart_discount = Number(document.getElementById('mg-info').dataset.cart_discount)/100;
  const line_items = JSON.parse(document.getElementById('mg-info').dataset.cart).filter(li => li.variant_id);

  line_items.forEach(item => {
    item.priceEach = item.priceEach.match(/[\d+.\d+|\d+]+/)[0];
  });

  const items_updated = await mgUpdateLineItems(line_items);
  if (!items_updated) {
    mgHandleError("Unable to update cart items");
    return;
  }

  // for adv, wejd, wvs (Wholesale B2B Solutions app)
  // mgAddDiscounts(line_items);

  if (!address) {
    const address_fields = document.querySelectorAll(".amv-tax-app-modal .address-field");

    address = {};
    for (let i = 0; i < address_fields.length; i++) {
      if (address_fields[i].name == "province") {
        address["province"] = address_fields[i].selectedOptions[0].text;
        address["province_code"] = address_fields[i].value;
      }
      else {
        address[address_fields[i].name] = address_fields[i].value;
      }
    }
  }

  const data = await mgPostData({shopify_domain, tax_exempt, cart_discount, form_data: address, line_items}, 'orders/v4');

  if (data.error) {
    mgHandleError(data.error);
  } else if (window.mgAddASF) {
    const fee_items_attached = await mgAddASF(data.id, shopify_domain);
    if (fee_items_attached) {
      mgRedirectToInvoiceURL(data.invoice_url);
    } else {
      mgHandleError("Unable to add fee items");
    }
  } else {
    mgRedirectToInvoiceURL(data.invoice_url);
  }
}
